export const objectToURLSearchParamsString = (_obj = {}) => {
	const queryString = Object.entries(_obj)
		.flatMap(([key, value]) => [value].flat().map((v) => [key, v]))
		.map((it) => it.join('='))
		.join('&');

	return queryString;
};